import { Component, OnInit } from '@angular/core';
import { BrowseobligorService } from '../services/browseobligor.service';
import { InvestorBrowseFilings } from '../Models/investor-browse-filings';
import { BrowseFilingTypes } from '../Models/browse-filing-types';
import { Router } from '@angular/router';

declare const FLFinancialStatementPageLoad: any;
declare function PDFWelcomeMessage(eventId): any;
declare function FLFinancialStatementresponsiveVoiceSpeak(placeholder, inputValue, keyCode, innerText, eventId, controlType, title, htmlFor, alt, key): any;
declare var $: any;
declare function BrowseObligorsponsiveVoiceSpeak(placeholder, inputValue, keyCode, innerText, eventId, controlType, title, htmlFor, alt, key): any;
declare function voiceForFilingHistoryDocumentCount(DocumentCount, innerText): any;
declare function voiceForLastFilingHistoryDocument(targetid, innerText, lateFilingMsg): any;
declare function FontSizeSettings(): any;
declare function CancelVoice(): any;
//declare function FontSizeSettingsFilingTypes(): any;
var documentTabIndex = 0;
var pdfCloseVoice = 0;
var IsLoadFontSizeSettings = 0;

@Component({
  selector: 'app-investor-browse-filing-types',
  templateUrl: './investor-browse-filing-types.component.html',
  styleUrls: ['./investor-browse-filing-types.component.css']
})
export class InvestorBrowseFilingTypesComponent implements OnInit {
  pathname = '';
  DefaultFilingType: string;
  public allDisclosureFilings: BrowseFilingTypes[];
  public allEventNotices: BrowseFilingTypes[];
  public BrowseFilingsArray: InvestorBrowseFilings[];

  constructor(private browseobligorService: BrowseobligorService, private router: Router) { }

  showModal(documentLink, tabindex) {
    debugger;
    //$("#frame").attr("src", documentLink);
    var w = 1000;
    var h = 800;
    var left = (screen.width / 2) - (w / 2);
    var top = (screen.height / 2) - (h / 2);
    // add inline if not in api part
    if (!documentLink.includes("inline")) {
      documentLink = documentLink + "&inline=1";
    }
    window.open(documentLink, "Document", 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);
    PDFWelcomeMessage("");
    documentTabIndex = tabindex;
  }

  onClickBrowseFilingTypes(filingType, filingTypeName) {
    debugger;    
    document.getElementById("PageObligar").innerText = filingTypeName;
    document.getElementById("spnPageObligar").innerText = filingTypeName;
    this.loadSearchObligors(localStorage.OBLIGOR_ID, filingType, "1");
    //FontSizeSettingsFilingTypes();
    document.getElementById("lblObligar").focus();
    return;
  }

  onKeyUpDocument(event: any, documentLink, tabindex) {
    debugger;    
    if (event.keyCode == 13) {
      //$("#frame").attr("src", documentLink);
      //$("#myModalFillingHistory").modal('show');
      var w = 1000;
      var h = 800;
      var left = (screen.width / 2) - (w / 2);
      var top = (screen.height / 2) - (h / 2);
      // add inline if not in api part
      if (!documentLink.includes("inline")) {
        documentLink = documentLink + "&inline=1";
      }
      window.open(documentLink, "Document", 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);
      PDFWelcomeMessage("");
      documentTabIndex = tabindex;
    }
  }

  onKeyUp(event: any, filingType, filingTypeName) {
    debugger;
    if (event.target.id == "tblPageObligar" && event.keyCode == 9) {
      BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, event.target.innerText, "tddocumentDesc", event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key);
      document.getElementById("tddocumentDesc").focus();
      return;
    }

    if (event.target.id == "DocumentCategories" && event.keyCode == 27) {
      document.getElementById("SkipMainContentfooter").focus();
      BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, "Skip the Footer", "SkipMainContentfooter", event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key)
      return;
    }
    if (event.target.id == "DisclosureFilings" && event.keyCode == 27) {
      document.getElementById("SkipMainContentfooter").focus();
      BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, "Skip the Footer", "SkipMainContentfooter", event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key)
      return;
    }
  
    if (event.target.id == "EventNoticesID" && event.keyCode == 27) {
      document.getElementById("SkipMainContentfooter").focus();
      BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, "Skip the Footer", "SkipMainContentfooter", event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key)
      return;
    }
    if (event.target.id == "EventNotices" && event.keyCode == 27) {
      document.getElementById("SkipMainContentfooter").focus();
      BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, "Skip the Footer", "SkipMainContentfooter", event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key)
      return;
    }
    
    var lateFilingMsg = "";
    var finalDocumentLinkID = "";
    if (event.target.id.includes("_")) {
      var tdDocumentLinkID = event.target.id;
      var remove_after = tdDocumentLinkID.indexOf('_');
      finalDocumentLinkID = tdDocumentLinkID.substring(0, remove_after);
    }

    if ((event.target.id == "tddocumentDesc" || finalDocumentLinkID == "tdDocumentLink" || event.target.id == "tdDueDate" || event.target.id == "tdFilingDate") && (event.keyCode == 9)) {
      event.preventDefault();
      return;
    }

    if (event.keyCode == 13 && finalDocumentLinkID == "tdDocumentLink") {      
      var w = 1000;
      var h = 800;
      var left = (screen.width / 2) - (w / 2);
      var top = (screen.height / 2) - (h / 2);
      window.open(filingType, "Document", 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);
      PDFWelcomeMessage("");
      documentTabIndex = filingTypeName;
      return;
    }

    if (event.target.id == "myModalFillingHistory" && event.keyCode == 9) {
      $('#frame').focus();
      pdfCloseVoice = 0;
      return;
    }
    if (event.target.id == "frame" && event.keyCode == 16) {
      pdfCloseVoice = 0;
    }

    if (event.target.id == "lblHoldPDFModelNext") {
      $('#btnClosePDF').focus();
      PDFWelcomeMessage("btnClosePDF");
      return;
    }
    if (event.target.id == "lblHoldPDFModelPrev") {
      $('#frame').focus();
      document.getElementById("SkipMainContentfooter").focus();
      BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, "Skip the Footer", "SkipMainContentfooter", event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key)
      return;
    }

    if (event.target.id == "btnClosePDF" && event.keyCode == 9 && pdfCloseVoice == 0) {
      PDFWelcomeMessage(event.target.id);
      pdfCloseVoice = 1;
      return;
    }
    // Call API when press Enter on Menu
    if (event.keyCode == 13 && (event.target.id == "DisclosureFilings" || event.target.id == "EventNotices")) {
      document.getElementById("PageObligar").innerText = filingTypeName;
      document.getElementById("spnPageObligar").innerText = filingTypeName;
      CancelVoice();
      this.loadSearchObligors(localStorage.OBLIGOR_ID, filingType, "1");
      //FontSizeSettingsFilingTypes();
      document.getElementById("lblObligar").focus();
      return;
    } 

    if (event.keyCode != 17) {
      if (event.keyCode == 27) {
        document.getElementById("DocumentCategories").focus();       
        FLFinancialStatementresponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("DocumentCategories").innerText, document.getElementById("DocumentCategories").id, event.target.type, document.getElementById("DocumentCategories").title, event.target.htmlFor, event.target.alt, event.key);
        //document.getElementById("SkipMainContentfooter").focus();
        //BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, "Skip the Footer", "SkipMainContentfooter", event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key)
      }
      if (event.keyCode == 9) {
        if (event.target.id == "DocumentCategories") {
          FLFinancialStatementresponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, event.target.innerText, event.target.id, event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key);
        }
        if (event.target.id == "DisclosureFilings") {
          FLFinancialStatementresponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, event.target.innerText, event.target.id, event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key);
        }
        if (event.target.id == "EventNoticesID") {
          FLFinancialStatementresponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, event.target.innerText, event.target.id, event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key);
        }
        if (event.target.id == "EventNotices") {
          FLFinancialStatementresponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, event.target.innerText, event.target.id, event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key);
        }
        if (event.target.id == "lblObligar") {
          FLFinancialStatementresponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, event.target.innerText, event.target.id, event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key);
        }
        if (event.target.id == "PageObligar") {
          FLFinancialStatementresponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, event.target.innerText, event.target.id, event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key);
        }
        if (event.target.id == "tddocumentDesc") {
          BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, event.target.innerText, event.target.id, event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key);
        }
      }
      if (event.keyCode == 13) {
        if (event.target.id == "DisclosureFilings") {
          document.getElementById("lblObligar").focus();
          document.getElementById("lblObligar").tabIndex = 151;
          FLFinancialStatementresponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("lblObligar").innerText, document.getElementById("lblObligar").id, event.target.type, document.getElementById("lblObligar").title, event.target.htmlFor, event.target.alt, event.key);

        }
        if (event.target.id == "EventNotices") {
          document.getElementById("lblObligar").focus();
          document.getElementById("lblObligar").tabIndex = 151;
          FLFinancialStatementresponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("lblObligar").innerText, document.getElementById("lblObligar").id, event.target.type, document.getElementById("lblObligar").title, event.target.htmlFor, event.target.alt, event.key);
        }
      }
      if (event.keyCode == 38) {
        var parent_cell = $(event.target).index();
        var child_cell = $(event.target).index();
        $(event.target).parent().prev().children("td").eq(parent_cell).focus();
        if (event.target.id == "tddocumentDesc") {
          var innerText = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[0].innerText;
          var title = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[0].title;
          BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, innerText, event.target.id, event.target.type, title, event.target.htmlFor, event.target.alt, event.key)
        }
        if (finalDocumentLinkID == "tdDocumentLink") {
          var innerText = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[1].innerText;
          var title = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[1].title;
          BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, innerText, finalDocumentLinkID, event.target.type, title, event.target.htmlFor, event.target.alt, event.key)
        }
        if (event.target.id == "tdDueDate") {
          var innerText = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[2].innerText;
          var title = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[2].title;
          BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, innerText, event.target.id, event.target.type, title, event.target.htmlFor, event.target.alt, event.key)
        }
        if (event.target.id == "tdFilingDate") {
          var innerText = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[3].innerText;
          var title = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[3].title;
          if ($(event.target).parent().prev().children("td").eq(child_cell).prevObject[3].getElementsByClassName("highlight").length == 1) {
            lateFilingMsg = "This is a late filing.";
          }
          BrowseObligorsponsiveVoiceSpeak(lateFilingMsg, event.target.value, event.keyCode, innerText, event.target.id, event.target.type, title, event.target.htmlFor, event.target.alt, event.key)
        }

        return;
      }
      else if (event.keyCode == 40) {
        var child_cell = $(event.target).index();
        $(event.target).parent().next().children("td").eq(child_cell).focus();
        if (event.target.id == "tddocumentDesc") {
          var innerText = $(event.target).parent().next().children("td").eq(child_cell).prevObject[0].innerText;
          var title = $(event.target).parent().next().children("td").eq(child_cell).prevObject[0].title;
          BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, innerText, event.target.id, event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key)
        }
        if (finalDocumentLinkID == "tdDocumentLink") {
          var innerText = $(event.target).parent().next().children("td").eq(child_cell).prevObject[1].innerText;
          var title = $(event.target).parent().next().children("td").eq(child_cell).prevObject[1].title;
          BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, innerText, finalDocumentLinkID, event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key)
        }
        if (event.target.id == "tdDueDate") {
          var innerText = $(event.target).parent().next().children("td").eq(child_cell).prevObject[2].innerText;
          var title = $(event.target).parent().next().children("td").eq(child_cell).prevObject[2].title;
          BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, innerText, event.target.id, event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key)
        }
        if (event.target.id == "tdFilingDate") {
          var innerText = $(event.target).parent().next().children("td").eq(child_cell).prevObject[3].innerText;
          var title = $(event.target).parent().next().children("td").eq(child_cell).prevObject[3].title;
          if ($(event.target).parent().next().children("td").eq(child_cell).prevObject[3].getElementsByClassName("highlight").length == 1) {
            lateFilingMsg = "This is a late filing.";
          }
          if (typeof $(event.target).parent().next().next().children("td").eq(child_cell).prevObject[0] == "undefined") {
            voiceForLastFilingHistoryDocument("tdFilingDate", innerText, lateFilingMsg);
          }
          else {            
            BrowseObligorsponsiveVoiceSpeak(lateFilingMsg, event.target.value, event.keyCode, innerText, event.target.id, event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key)
          }          
        }
        return;
      }
      else if (event.keyCode == 39) {
        if (event.target.id == "tddocumentDesc") {
          var target = $(event.target).next();
          $(target).trigger('focus');
          var finaltdDocLinkID = "";
          if (target[0].id.includes("_")) {
            var tdDocLinkID = target[0].id;
            var remove_after = tdDocLinkID.indexOf('_');
            finaltdDocLinkID = tdDocLinkID.substring(0, remove_after);
          }
          if (finaltdDocLinkID == "tdDocumentLink") {
            BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, target[0].innerHTML.includes(true), finaltdDocLinkID, event.target.type, target[0].title, event.target.htmlFor, event.target.alt, event.key)
          }
        }
        if (finalDocumentLinkID == "tdDocumentLink") {
          var target = $(event.target).next();
          $(target).trigger('focus');
          if (target[0].id == "tdDueDate") {
            BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, target[0].innerText, target[0].id, event.target.type, target[0].title, event.target.htmlFor, event.target.alt, event.key)
          }
        }
        if (event.target.id == "tdDueDate") {
          var target = $(event.target).next();
          $(target).trigger('focus');
          if (target[0].id == "tdFilingDate") {
            if (target[0].getElementsByClassName("highlight").length == 1) {
              lateFilingMsg = "This is a late filing.";
            }
            if (typeof $(event.target).parent().next().children("td").eq(child_cell).prevObject[0] == "undefined") {
              voiceForLastFilingHistoryDocument("tdFilingDate", target[0].innerText, lateFilingMsg);
            }
            else {                            
              BrowseObligorsponsiveVoiceSpeak(lateFilingMsg, event.target.value, event.keyCode, target[0].innerText, target[0].id, event.target.type, target[0].title, event.target.htmlFor, event.target.alt, event.key)
            }            
          }
        }
        if (event.target.id == "tdFilingDate") {
          var obligorDescIndex = 0;
          $(event.target).parent().next().children("td").eq(obligorDescIndex).focus();
          if (event.target.id == "tdFilingDate") {
            if (typeof $(event.target).parent().next().children("td").eq(child_cell).prevObject[0] == "object") {
              var innerText = $(event.target).parent().next().children("td").eq(child_cell).prevObject[0].innerText;
              var title = $(event.target).parent().next().children("td").eq(child_cell).prevObject[0].title;
              BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, innerText, "tddocumentDesc", event.target.type, "", event.target.htmlFor, event.target.alt, event.key)
            }
          }
        }
      }
      else if (event.keyCode == 37) {

        if (event.target.id == "tdFilingDate") {
          var target = $(event.target).prev();
          $(target).trigger('focus');
          if (target[0].id == "tdDueDate") {
            BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, target[0].innerText, target[0].id, event.target.type, target[0].title, event.target.htmlFor, event.target.alt, event.key)
          }
        }
        if (event.target.id == "tdDueDate") {
          var target = $(event.target).prev();
          $(target).trigger('focus');
          var finaltdDocLinkID = "";
          if (target[0].id.includes("_")) {
            var tdDocLinkID = target[0].id;
            var remove_after = tdDocLinkID.indexOf('_');
            finaltdDocLinkID = tdDocLinkID.substring(0, remove_after);
          }
          if (finaltdDocLinkID == "tdDocumentLink") {
            BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, target[0].innerText, finaltdDocLinkID, event.target.type, target[0].title, event.target.htmlFor, event.target.alt, event.key)
          }
        }
        if (finalDocumentLinkID == "tdDocumentLink") {
          var target = $(event.target).prev();
          $(target).trigger('focus');
          if (target[0].id == "tddocumentDesc") {
            BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, target[0].innerText, target[0].id, event.target.type, target[0].title, event.target.htmlFor, event.target.alt, event.key)
          }
        }
        if (event.target.id == "tddocumentDesc") {
          var obligorDescIndex = 3;
          $(event.target).parent().prev().children("td").eq(obligorDescIndex).focus();
          if (event.target.id == "tddocumentDesc") {
            if (typeof $(event.target).parent().prev().children("td").eq(child_cell).prevObject[3] == "object") {
              var innerText = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[3].innerText;
              var title = $(event.target).parent().prev().children("td").eq(child_cell).prevObject[3].title;
              if ($(event.target).parent().prev().children("td").eq(child_cell).prevObject[3].getElementsByClassName("highlight").length == 1) {
                lateFilingMsg = "This is a late filing.";
              }
              BrowseObligorsponsiveVoiceSpeak(lateFilingMsg, event.target.value, event.keyCode, innerText, "tdFilingDate", event.target.type, title, event.target.htmlFor, event.target.alt, event.key)
            }
          }
        }
      }
    }
  };

  ngOnInit() {
    debugger;    
    //=========Caption Hide Show=============//
    if ($('#hidglbVarOnOff').val() == "OFF") {
      $('#captionhideshow').hide();
      $('#btnOnOff').val('OFF')
    }
    else {
      $('#captionhideshow').show();
      $('#btnOnOff').val('ON')
    }
    //============Voice Annotation On/Off=========
    if ($('#hidVoiceOnOff').val() == "OFF") {
      $('#btnVoiceAnnotation').val('OFF');
      $('#hidVoiceOnOff').val('OFF');
      $('#btnPlayPause').css('display', 'none');
    }
    else {
      $('#btnVoiceAnnotation').val('ON');
      $('#hidVoiceOnOff').val('ON');
      $('#btnPlayPause').css('display', 'block');
    }

    FLFinancialStatementPageLoad();
    this.pathname = window.location.pathname;
    var OBLIGOR_ID = localStorage.OBLIGOR_ID;
    var OBLIGOR_DESC = localStorage.OBLIGOR_DESC;
    document.getElementById("lblObligar").innerText = OBLIGOR_DESC;
    document.getElementById("spnlblObligar").innerText = OBLIGOR_DESC;
    this.loadInvestorBrowseFilingTypes(OBLIGOR_ID);    
    //FontSizeSettingsFilingTypes();
    $('#myModalFillingHistory').on('shown.bs.modal', function () {
      debugger;
      $('#frame').focus();
      pdfCloseVoice = 0;
      //WebcastOpneModelMessage("PlayWebcast");
    });
    $("#myModalFillingHistory").on("hidden.bs.modal", function () {
      debugger;
      var DocumentID = "tdDocumentLink_" + documentTabIndex;
      document.getElementById(DocumentID).focus();
      PDFWelcomeMessage("CoulmnDocument");
      return;
    });
  }

  setFontSizeSettings() {    
    if (IsLoadFontSizeSettings == 1) {
      FontSizeSettings();
      IsLoadFontSizeSettings = 0;
    }
  }

  //ngAfterViewInit() {
  //  FontSizeSettingsFilingTypes();
  //} 

  public InvestorBrowseFilings: InvestorBrowseFilings;

  // load Obligors with obligorId and filingType
  loadSearchObligors(obligorId: string, filingType: string, documentCountVoice: string) {    
    this.browseobligorService.GetInvestorBrowseFilingsWithFilingType(obligorId, filingType).subscribe(data => {
      debugger;
      if (data['length'] > 0) {
        // Speak for how many documents are in each subcategory.
        if (documentCountVoice == "1") {
          voiceForFilingHistoryDocumentCount(data['length'], localStorage.OBLIGOR_DESC);
        }

        // Check for Filing Date is greater than Due Date        
        var BrowseFilingsArray = [];

        for (var i = 0; i < data['length']; i++) {
          var documentDesc = data[i].documentDesc;//JSON.stringify(data[0].documentDesc)
          var documentLink = data[i].documentLink;
          var filingDate = data[i].filingDate;
          var dueDate = data[i].dueDate;
          var IsDueDate = false;

          // Check for Filing Date is greater than Due Date
          if (filingDate != null && filingDate != "" && dueDate != null && dueDate != "") {
            var dueDateArr = dueDate.split(',');
            for (var j = 0; j < dueDateArr.length; j++) {
              var dateDue = Date.parse(dueDateArr[j]);
              var fillDate = Date.parse(filingDate);
              if (fillDate > dateDue) {
                IsDueDate = true;
              }
            }
          }

          var productJSON = { "documentDesc": documentDesc, "documentLink": documentLink, "filingDate": filingDate, "dueDate": dueDate, "IsDueDate": IsDueDate };
          BrowseFilingsArray.push(productJSON);
        }

        this.BrowseFilingsArray = BrowseFilingsArray;
        IsLoadFontSizeSettings = 1;
      }
    }, error => {
      console.log(error);
      debugger;
      if (error.status == "403") {
        sessionStorage.removeItem("sessionData");
        this.checkSession_onSearch();
      }
    });
  }

  // check session
  checkSession_onSearch() {
    // check session on search click
    if (!sessionStorage['sessionData']) {
      this.router.navigate(['registration']);
      return;

    }
  }

  // InvestorBrowseFilingTypes
  loadInvestorBrowseFilingTypes(obligorId: string) {
    debugger;
    this.browseobligorService.GetInvestorBrowseFilingTypes(obligorId).subscribe(data => {
      debugger;
      if (data['length'] > 0) {
        // Set Route Name which exists in InvestorBrowseFilingTypes for a given obligor ID, the categories and types of documents that exist for that obligor.
        if (data[0].filingTypes.length > 0) {
          this.DefaultFilingType = data[0].filingTypes[0].filingType;
          this.allDisclosureFilings = data[0].filingTypes;
        }
        if (data['length'] == 2) {
          this.allEventNotices = data[1].filingTypes;
        }
        if (data['length'] == 2 && this.DefaultFilingType == "") {
          this.DefaultFilingType = data[1].filingTypes[0].filingType;
        }

        // If there are no Event Notices and Disclosure document do not show the Disclosure document and Event Notices.
        // Disclosure Filings
        if (typeof (data[0]) == "undefined") {
          document.getElementById("DocumentCategories").style.display = "none";
        }
        else {
          document.getElementById("DocumentCategories").style.display = "block";
        }
        // Event Notices
        if (typeof (data[1]) == "undefined") {
          document.getElementById("EventNoticesID").style.display = "none";
        }
        else {
          document.getElementById("EventNoticesID").style.display = "block";
        }

        this.loadSearchObligors(obligorId, this.DefaultFilingType, "0");
        document.getElementById("spnPageObligar").innerText = this.DefaultFilingType;
      }
    }
     , error => {
        console.log(error);
        debugger;
        if (error.status == "403") {
          sessionStorage.removeItem("sessionData");
          this.checkSession_onSearch();
        }
      });
  }

}
